<template>
  <div>
    <general-top-bar :title="$t('reports.paymentTypes')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6" v-if="showLocations">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="paymentMethods && paymentMethods.length">
            <label class="form-label text-start w-100">{{$t('addOrder.choosePay')}}</label>
            <select class="form-control mar-bt-15" v-model="selected_payment_method">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="val in paymentMethods">
                <option :label="val.name" :value="val.id">{{val.name}}</option>
              </template>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns">
          <chart-bars-card
            v-loading="loading"
            :chart-data="paymentMethodSales.data"
            :chart-options="paymentMethodSales.options"
            ref="paymentMethodSales"
          >
            <template v-if="noData">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
            </div>
            
            <div slot="footer">
              <div class="chart-legend" style="display: flex; flex-wrap: wrap;">
                <div
                  v-for="(label, index) in paymentMethodSales.data.labels"
                  :key="index"
                  style="display: flex; align-items: center; margin-right: 12px;"
                >
                  <i
                    class="fa fa-circle"
                    :style="{ color: colors[index % colors.length], marginRight: '5px' }"
                  ></i>
                  <span>{{ label }} - {{ paymentMethodSales.data.series[0][index] }}</span>
                </div>
              </div>
            </div>
          </chart-bars-card>

          <!-- Totals Section -->
          <div v-if="ordersTableData.data && ordersTableData.data.length > 0" class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <div class="card center-sales-report-stats" style="height: 100% !important;">
                  <div class="card-content" v-loading="loading">
                    <div class="report-container">
                      <div class="report-row">
                        <div class="report-col left-align">{{$t('reports.total')}}</div>
                        <div class="report-col right-align">{{formatMoneyAmount(totalAmount)}}</div>
                      </div>
                      <div class="report-row">
                        <div class="report-col left-align">{{$t('reports.orderCounter')}}</div>
                        <div class="report-col right-align">{{totalCounter}}</div>
                      </div>
                      <!-- <div class="report-row">
                        <div class="report-col left-align">{{$t('reports.paymentMethod')}}</div>
                        <div class="report-col right-align">{{ordersTableData.data.length}} {{$t('reports.types')}}</div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <data-tables-server
            v-loading="loading"
            :data="ordersTableData.data"
            :total="ordersTableData.total"
            :search-def="{show: false}"
            class="report-sales"
            key="sales-table"
            style="width: 100%"
            ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="80" prop="payment_type" :label="$t('reports.paymentMethod')">
              <template slot-scope="props">
                  {{ $t('paymentTypes.' + props.row.payment_type) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="counter" :label="$t('reports.orderCounter')" />
            <el-table-column class-name="centered-cell" :min-width="80" prop="total_amount" :label="$t('reports.totalAmount')" />
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard
  },
  props: {
    isSalesPaymentMethod: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSalesPaymentMethod () {
      if (this.isSalesPaymentMethod) {
        this.getOrders()
      }
    }
  },
  created () {
    this.getPaymentMethods()
    this.getOrders()
    this.verifyUserLocations()
    this.verifyUserMethods()
  },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      paymentMethodSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      paymentMethods: [],
      selected_payment_method: '',
      loading: true,
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totalAmount: 0,
      totalCounter: 0,
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      // use_tips: this.$session.get('tips_use')
      hasRceipt: null,
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        // '#4caf50', // green
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        // '#e91e63', // pink
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false
    }
  },
  methods: {
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data
              .filter(item => item !== 'SPLIT')
              .map(item => {
                return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
              })
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods']
          .filter(item => item !== 'SPLIT')
          .map(item => {
            return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
          })
        Vue.set(this, 'paymentMethods', result)
      }
    },
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isSalesPaymentMethod) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        payment_method: this.selected_payment_method
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const hasReceiptValue = (this.hasRceipt && this.hasRceipt.value) || null

      this.apiRequest('/reports/v2/sales-payment-type' + '?page=' + page + '&pageSize=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, response => {
        if (response.status) {
          if (response.data.payment_types && response.data.payment_types.length) {
            this.noData = false
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.data.table_data.length

            this.totalAmount = response.data.total || 0
            this.totalCounter = response.data.total_counter || 0

            this.$nextTick(() => {
              this.paymentMethodSales.options.chartPadding = {
                top: 30,
                right: 10,
                bottom: 20,
                left: 20
              }

              if (response.data.payment_types && response.data.payment_types.length) {
                this.paymentMethodSales.data.labels = response.data.payment_types.map(item => {
                  return this.$t('paymentTypes.' + item)
                })
              }

              this.paymentMethodSales.data.series = [response.data.total_amounts]
              this.$refs.paymentMethodSales.initChartAndReturn()

              if (this.$refs.paymentMethodSales.chart) {
                this.$refs.paymentMethodSales.chart.on('draw', (data) => {
                  if (data.type === 'bar') {
                    data.element.attr({
                      style: `stroke: ${this.colors[data.index % this.colors.length]}; stroke-width: 60px;`
                    })

                    if (data.type === 'label' && data.axis.units.pos === 'x') {
                      const words = data.text.split(' ')
                      const labelHtml = words.join('<br>')

                      data.element.remove()

                      const fo = data.group.elem('foreignObject', {
                        x: data.x - 25,
                        y: data.y,
                        width: 60,
                        height: 50,
                        style: 'font-size: 12px; text-align: center; overflow: visible;'
                      })

                      fo.elem('xhtml:div', {
                        xmlns: 'http://www.w3.org/1999/xhtml',
                        style: 'width: 40px; white-space: normal; word-wrap: break-word; text-align: center;'
                      }).html(labelHtml)
                    }
                  }
                })
              }
            })
          } else {
            this.paymentMethodSales.data.labels = []
            this.paymentMethodSales.data.series = [[]]
            this.noData = true
            this.ordersTableData.data = []
            this.ordersTableData.total = 0

            if (this.$refs.paymentMethodSales.chart) {
              this.$refs.paymentMethodSales.initChartAndReturn()
            }
          }
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/sales-payment-type-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/SalesPaymentMethod.vue